import request from '@/utils/http';
import { SRM } from '../constant/constant.js';
// 供应商变更-查询列表
export const getTableData = (params) => {
    return request({
        url: `/api-srm-web/supplier/alterationInfos`,
        method: 'post',
        data: params
    });
};
// 工作台-查询列表
export const getChangeApplyInfos = (params) => {
    return request({
        url: `/api-srm-web/supplier/changeApplyInfos`,
        method: 'post',
        data: params
    });
};
// 供应商变更-更多变更明细
export const getDetailsData = (params) => {
    return request({
        url: `/api-srm-web/supplier/changeRecords`,
        method: 'post',
        data: params
    });
};
// 供应商变更-查看
export const examineData = (changeApplyNo) => {
    return request({
        url: `/api-srm-web/supplier/changeApply/${changeApplyNo}`,
        method: 'get'
    });
};
// 管理端-变更按钮-获取数据
export const changeApplyBtn = (params) => {
    return request({
        url: `/api-srm-web/supplier/changeApply/lastTime`,
        method: 'get',
        params: params
    });
};
// 供应商变更-驳回
export const overrulesData = (params) => {
    return request({
        url: `/api-srm-web/supplier/changeApply/rejection`,
        method: 'post',
        data: params
    });
};
// 供应商变更-查看&&变更-账户信息-提交审批
export const manageChangeApplyBank = (changeApplyNo, accountId) => {
    return request({
        url: `/api-srm-web/supplier/changeApply/bankAccount/pass/${changeApplyNo}/${accountId}`,
        method: 'put'
    });
};
// 变更申请-基础信息-提交审批
export const supplierBasicSubmit = (params) => {
    return request({
        url: `/api-srm-web/supplier/basicInfoAlteration`,
        method: 'post',
        data: params
    });
};
// 变更申请-财务信息-提交审批
export const supplierFinanceSubmit = (params) => {
    return request({
        url: `/api-srm-web/supplier/financeInfoAlteration`,
        method: 'post',
        data: params
    });
};
// 变更申请-账户信息-提交审批
export const supplierBankSubmit = (params) => {
    return request({
        url: `/api-srm-web/supplier/bankAccount/changeBySupplier`,
        method: 'post',
        data: params
    });
};
// 承运商类别-运输方式
export const getBusinessType = (params) => {
    return request({
        url: `/api-srm-web/supplier/manage/chooseBusinessType`,
        method: 'post',
        data: params
    });
};
// 承运商类别-承运商类别
export const getCarriersType = (params) => {
    return request({
        url: `/api-srm-web/supplier/manage/chooseTransport`,
        method: 'post',
        data: params
    });
};
// 待办-提交审批
export const getChangeApplyAudit = (changeApplyNo) => {
    return request({
        url: `/api-srm-web/supplier/getChangeApplyAudit/${changeApplyNo}`,
        method: 'get'
    });
};
// 管理端-变更按钮-提交MIP
export const changeApplyIflow = (params) => {
    return request({
        url: `/api-srm-web/supplier/changeApplyIflowCreateDraft`,
        method: 'post',
        data: params
    });
};
// 变更申请-承运商类别-提交审批
export const carriersTypeSubmit = (params) => {
    return request({
        url: `/api-srm-web/supplier/carrierTypeAlteration`,
        method: 'post',
        data: params
    });
};
// 供应商变更-获取对应资质信息
export const getSupplierBasicQualificationForChange = (params) => {
    return request({
        url: `/api-srm-web/supplier/supplierQualificationInfo/getSupplierBasicQualificationForChange`,
        // url: `/fyq/supplierQualificationInfo/getSupplierBasicQualificationForChange`,
        method: 'post',
        data: params
    });
};
// 变更申请-其他信息-提交审批
export const otherSubmit = (params) => {
    return request({
        url: `/api-srm-web/supplier/otherInfoAlteration`,
        method: 'post',
        data: params
    });
};
// 变更申请-合作方式-提交审批
export const corporateSubmit = (params) => {
    return request({
        url: `/api-srm-web/supplier/corporateTypeAlteration`,
        method: 'post',
        data: params
    });
};
// 变更申请-合作方式-提交审批
export const checkCorporate = (params) => {
    return request({
        url: `/api-srm-web/supplier/checkIfCanCorporateAlteration`,
        method: 'post',
        data: params
    });
};
// 黑名单临时付款流程提交
export const blackSupplierPaySubmit = (params) => {
    return request({
        url: `/api-srm-web/supplier/blackSupplierPaySubmit`,
        method: 'post',
        data: params
    });
};
// 黑名单临时付款取消提交
export const blackSupplierPayCancel = (params) => {
    return request({
        url: `/api-srm-web/supplier/blackSupplierPayCancel`,
        method: 'get',
        params: params
    });
};

// 租仓信息-提交审批
export const submitMip = data => {
    return request({
        url: `/api-srm-web/supplier/manage/submitMip`,
        method: 'post',
        data,
    });
};

// 获取承运商变更所需资质和页签
export const getQualificationInfoAndTabForChange = data => {
    return request({
        url: `/api-srm-web/supplier/supplierQualificationInfo/getQualificationInfoAndTabForChange`,
        method: 'post',
        data,
    });
};

// 承运商变更补充常跑线路校验
export const supplierCommonRouteAddTemp = data => {
    return request({
        url: `/api-srm-web/supplier/supplierCommonRoute/addTemp`,
        method: 'post',
        data,
    });
};

// 承运商变更补充零担对接平台校验
export const supplierLessSystemCreateTemp = data => {
    return request({
        url: `/api-srm-web/supplier/supplierLessSystem/createTemp`,
        method: 'post',
        data,
    });
};
